import { render } from "./IconStraighten.vue?vue&type=template&id=bc8d4130"
import script from "./IconStraighten.vue?vue&type=script&lang=js"
export * from "./IconStraighten.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__